import { EditorState, Modifier, SelectionState } from 'draft-js';

export const openingEmptyListItem = (props) => {
  const key = props.editorState.getSelection().getAnchorKey();
  const block = props.editorState.getCurrentContent().getBlockForKey(key);
  const text = block.getText();
  const type = block.getType();
  const firstBlockKey = props.editorState
    .getCurrentContent()
    .getFirstBlock()
    .getKey();

  return (
    firstBlockKey === key &&
    (type === 'ordered-list-item' || type === 'unordered-list-item') &&
    text === ''
  );
};

export const deleteAtomicBlock = (props, blockKey) => {
  const content = props.editorState.getCurrentContent();
  const entityBlockLength = content.getBlockForKey(blockKey).getLength();
  const withoutAtomicEntity = Modifier.removeRange(
    content,
    new SelectionState({
      anchorKey: blockKey,
      anchorOffset: 0,
      focusKey: blockKey,
      focusOffset: entityBlockLength,
    }),
    'backward'
  );
  let selectionAfter = SelectionState.createEmpty(
    props.editorState.getSelection().getAnchorKey()
  );
  selectionAfter = selectionAfter.merge({
    hasFocus: true,
  });
  const blockMap = withoutAtomicEntity.getBlockMap().delete(blockKey);
  const withoutAtomic = withoutAtomicEntity.merge({
    blockMap,
    selectionAfter: selectionAfter,
  });
  return EditorState.push(props.editorState, withoutAtomic, 'remove-range');
};

export const deletingAtomicBlock = (props) => {
  if (!props.editorState.getCurrentContent().hasText()) {
    return false;
  }
  const selection = props.editorState.getSelection();
  const atBlockStart =
    selection.anchorOffset === selection.focusOffset &&
    selection.anchorOffset === 0;
  if (!atBlockStart) {
    return false;
  }
  const blockKey = props.editorState.getSelection().getAnchorKey();
  const content = props.editorState.getCurrentContent();
  const prevBlockKey = content.getKeyBefore(blockKey);
  if (!prevBlockKey) {
    return false;
  }
  const prevBlock = content.getBlockForKey(prevBlockKey);
  if (prevBlock.getType() === 'atomic') {
    return prevBlockKey;
  }
  return false;
};

export const unstyledAsterisk = (props) => {
  const key = props.editorState.getSelection().getAnchorKey();
  const block = props.editorState.getCurrentContent().getBlockForKey(key);
  const text = block.getText();
  const type = block.getType();
  return type === 'unstyled' && text === '*';
};

export const unstyledHyphen = (props) => {
  const key = props.editorState.getSelection().getAnchorKey();
  const block = props.editorState.getCurrentContent().getBlockForKey(key);
  const text = block.getText();
  const type = block.getType();
  return type === 'unstyled' && text === '-';
};

export const unstyledListNumber = (props) => {
  const key = props.editorState.getSelection().getAnchorKey();
  const block = props.editorState.getCurrentContent().getBlockForKey(key);
  const text = block.getText();
  const type = block.getType();
  return type === 'unstyled' && text === '1.';
};

export const Efuncs = {
  openingEmptyListItem,
  deleteAtomicBlock,
  deletingAtomicBlock,
  unstyledAsterisk,
  unstyledHyphen,
  unstyledListNumber,
};
